import { render } from "./ProjectParticipationSearchWidget.vue?vue&type=template&id=437f6a6b&ts=true"
import script from "./ProjectParticipationSearchWidget.ts?vue&type=script&lang=ts&external"
export * from "./ProjectParticipationSearchWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__